/** Rapor adındaki "PTR-" önekini ve harf dışı karakterleri temizler. */
export const formatName = (inputName) => {
  return String(inputName?.name ?? inputName ?? "")
    .replace(/^PTR-|[^a-zA-Z\sıIğĞüÜşŞiİöÖçÇ]/g, "")
    .trim();
};
